const config = {
  baseApi: process.env.REACT_APP_BASE_API,
  msalClientId: process.env.REACT_APP_MSAL_CLIENT_ID,
  msalRedirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
  msalScopes: process.env.REACT_APP_MSAL_SCOPES,
};
export default config;
